/* storybook-check-ignore */
import { Button } from '@opendoor/bricks/core';
import { ListingWithComputedProperties } from 'declarations/exclusives/listing';
import { getExclusivesEventHomeInfo, getIsOOMLS } from 'helpers/exclusives/listing';
import noop from 'lodash/noop';
import useExclusiveAnalytics from '../hooks/useExclusiveAnalytics';

export default function BuyButton({
  text: textProp,
  shrinkText,
  listing,
  type,
  disabled,
}: {
  text?: string;
  type: 'reserve' | 'make_offer';
  disabled?: boolean;
  shrinkText?: boolean;
  listing: ListingWithComputedProperties;
}) {
  const { trackExclusivesEvent } = useExclusiveAnalytics();
  const text = shrinkText && textProp?.includes('Buy it now') ? 'Buy it now' : textProp;
  if (type === 'reserve') {
    return (
      <Button
        as="a"
        width="100%"
        variant="secondary"
        aria-label="Buy this home"
        className="buy-button"
        disabled={disabled}
        onClick={() => {
          trackExclusivesEvent(
            'exclusives-checkout',
            'instructions-viewed',
            listing,
            getExclusivesEventHomeInfo(listing),
          );
        }}
        textAlign="center"
        analyticsName="cosmos-exclusives-hero-buy-by-state"
        style={{ borderColor: '#B6B6B6' }}
        href={`/exclusives/homes/${encodeURIComponent(listing.slug)}/reserve`}
        {...(getIsOOMLS(listing) && {
          style: { borderColor: '#BCC3E7' },
          color: 'brand50',
          _hover: { opacity: 0.8, color: 'brand50', bg: 'neutrals20' },
        })}
      >
        {text}
      </Button>
    );
  }
  return (
    <Button
      as="a"
      width="100%"
      variant="primary"
      className="make-an-offer"
      aria-label="Make an offer"
      href={`/exclusives/homes/${encodeURIComponent(listing.slug)}/make-offer`}
      onClick={noop}
      analyticsName="cosmos-exclusives-hero-make-an-offer"
    >
      {text}
    </Button>
  );
}
